import React, { useEffect, useState } from "react";
import {
  createTimetableDay,
  getAllTimetableDays,
  deleteTimetableDay,
} from "../services/adminTimeTableServices";
import TimetableDayAccordion from "../components/time_table/TimetableDayAccordion";
import { utcToLocalDate } from "../../utils/dateTimeUtils";

const adminTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const AdminTimetablePage = () => {
  const [days, setDays] = useState([]);
  const [newDate, setNewDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    loadTimetable();
  }, []);

  const loadTimetable = async () => {
    try {
      setLoading(true);
      const res = await getAllTimetableDays();
      const convertedDays = res.data.map((day) => {
        const localDate = utcToLocalDate(day.date, adminTimeZone);
        const sessions = day.sessions
          ? [...day.sessions].sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
          : [];
        return { ...day, localDate, utcDate: day.date, sessions };
      });
      convertedDays.sort((a, b) => new Date(a.utcDate) - new Date(b.utcDate));
      setDays(convertedDays);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleCreateDay = async () => {
    if (!newDate) return alert("Please select a date");
    try {
      setCreating(true);
      await createTimetableDay({ date: newDate, timeZone: adminTimeZone });
      setNewDate("");
      loadTimetable();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to create day");
    } finally {
      setCreating(false);
    }
  };

  const handleDeleteDay = async (dayId) => {
    if (!window.confirm("Are you sure you want to delete this day?")) return;
    try {
      await deleteTimetableDay(dayId);
      loadTimetable();
    } catch (err) {
      alert(err.response?.data?.message || "Failed to delete day");
    }
  };

  return (
    <div className="admin-page">
      <h2>📅 Timetable Management</h2>

      <div className="add-day">
        <input
          type="date"
          value={newDate}
          onChange={(e) => setNewDate(e.target.value)}
        />
        <button onClick={handleCreateDay} disabled={creating}>
          {creating ? "Adding..." : "➕ Add Day"}
        </button>
      </div>

      {loading ? (
        <p>Loading timetable...</p>
      ) : days.length === 0 ? (
        <p>No timetable days found.</p>
      ) : (
        days.map((day) => (
          <TimetableDayAccordion
            key={day.id}
            day={day}
            reload={loadTimetable}
            deleteDay={handleDeleteDay}
          />
        ))
      )}
    </div>
  );
};

export default AdminTimetablePage;
